import { pink, grey } from '@mui/material/colors';

export const disabledColor = grey[400];
export const unSelectedColor = grey[600];
export const parentColor = pink[300];
